import { render, staticRenderFns } from "./SpecialistProfile.vue?vue&type=template&id=04ec199a&"
import script from "./SpecialistProfile.vue?vue&type=script&lang=js&"
export * from "./SpecialistProfile.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistProfile.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports